const ZIP_CODE_ADDRESSES_EVENT = 'addresses.zipcodeRetriever';
const ZIP_CODE_CP_EVENT = 'navigation-cp-webview';

module.exports = {
  ZIP_CODE_CP_EVENT,
  ZIP_CODE_ADDRESSES_EVENT,
};
